export const TransactionAction = {
  unknown: 0,
  payIn: 1,
  transfer: 2,
  payOut: 3
} as const;
export type TransactionActionType = keyof typeof TransactionAction;
export type TransactionActionCodes = (typeof TransactionAction)[keyof typeof TransactionAction];
